import { jsx, jsxs } from "react/jsx-runtime";
import "react";
import PropTypes from "prop-types";
import ChatBubble from "./ChatBubble.js";
import ChatNotification from "./ChatNotification.js";
import RichChatBubble from "./RichChatBubble.js";
import ChatIcon from "./ChatIcon.js";
import AdvisorIcon from "./AdvisorIcon.js";
const ChatLine = (props) => {
  if (props.message.source === "_chat-notification") {
    return /* @__PURE__ */ jsx(ChatNotification, { message: props.message.message }, 0);
  }
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: `chat-line ${props.message.source === "dpd" || props.message.source === "advisor" ? "receiver-line" : "sender-line"}`,
      children: [
        props.message.source === "dpd" ? /* @__PURE__ */ jsx(ChatIcon, {}) : "",
        props.message.source === "advisor" ? /* @__PURE__ */ jsx(AdvisorIcon, {}) : "",
        /* @__PURE__ */ jsx("div", { className: "chat-block", children: props.message.messages.map((msg, id) => {
          if (typeof msg === "undefined") {
            return null;
          }
          if (typeof msg === "string") {
            return /* @__PURE__ */ jsx(ChatBubble, { message: msg }, id);
          } else if (msg.type === "delivery-map" || msg.type === "ofd-map" || msg.type === "images") {
            return /* @__PURE__ */ jsx(RichChatBubble, { data: msg }, id);
          }
          return null;
        }) })
      ]
    }
  );
};
ChatLine.propTypes = {
  message: PropTypes.object
};
export {
  ChatLine as default
};
//# sourceMappingURL=ChatLine.js.map
